import type * as React from 'react';

import type { NodeProps } from '@xyflow/react';
import type { Node } from '@xyflow/react';

import type { BaseNodeData, NodeDefinition } from '../../types';

import { EmailActionConfig } from './EmailActionConfig';
import {
  EmailActionNode,
  emailActionVisualDefinition,
} from './EmailActionNode';
import {
  EmailActionConfigType,
  defaultEmailConfig,
  validateEmailConfig,
  getEmailPreviewText,
} from './schema';

export { EmailActionNode } from './EmailActionNode';
export { EmailActionConfig } from './EmailActionConfig';
export type { EmailActionConfigType } from './schema';

/** Full definition for the registry */
export const emailActionDefinition: NodeDefinition<EmailActionConfigType> = {
  ...emailActionVisualDefinition,
  category: 'action',
  paletteGroup: 'Notifications',
  NodeComponent: EmailActionNode as unknown as React.ComponentType<
    NodeProps<Node<BaseNodeData>>
  >,
  ConfigComponent: EmailActionConfig,
  defaultConfig: () => ({ ...defaultEmailConfig }),
  validateConfig: validateEmailConfig,
  getPreviewText: getEmailPreviewText,
};
